




















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class MessageSnackbar extends Vue {
  @Prop({ type: Number, default: 0 }) bottomOffset!: number

  get snackbar() {
    return this.$store.state.app.snackbar
  }
}
